import React, { FC } from 'react';

import SanityImage from 'atoms/SanityImage';

import { CaseStudyGridImageItem } from 'lib/sanity/types';

type Props = {
  className?: string;
  image: CaseStudyGridImageItem;
  snippet?: boolean | null;
  isFromSnippet?: boolean;
};

const CaseStudyGridItemImage: FC<Props> = ({
  className,
  image,
  snippet,
  isFromSnippet,
}) => {
  return (
    <div className={`ImageGridBlock__inner-wrapper ${className}`}>
      <SanityImage
        layout="fill"
        className="ImageGridBlock__single-image"
        priority={true}
        sizes="50vw"
        blur={snippet || isFromSnippet ? false : true}
        {...image.asset}
      />
    </div>
  );
};

export default CaseStudyGridItemImage;
